import { COLOR_CLASSES, COVER_POSITIONS } from './TabPanelCondition.constants';
/**
 * Конвертирует число в двоичную строку фиксированной длины
 */
export const toBinaryString = (number, length = 9) => {
    let binary = (number >>> 0).toString(2);
    while (binary.length < length) {
        binary = '0' + binary;
    }
    return binary;
};
/**
 * Извлекает биты для танков (первые 6 бит)
 */
export const extractTankBits = (guardNumber) => {
    return toBinaryString(guardNumber).split('').reverse().splice(0, 6).join('');
};
/**
 * Проверяет, является ли значение дефолтным
 */
export const isDefaultValue = (value, defaultValue) => {
    return value === defaultValue;
};
/**
 * Проверяет, является ли значение NA
 */
export const isNotAvailable = (value) => {
    return value === -2 || value === 65534;
};
/**
 * Форматирует значение датчика
 */
export const formatSensorValue = (value, defaultValue, unit = '') => {
    if (value === defaultValue)
        return '-1';
    if (isNotAvailable(value))
        return 'NA';
    return unit ? `${value} ${unit}` : value;
};
/**
 * Проверяет, открыта ли крышка
 */
export const isCoverOpen = (coverValue, limit = config.dunCoverLimit) => {
    return coverValue > limit;
};
/**
 * Определяет позицию открытых крышек
 */
export const getCoverPosition = (cover1, cover2) => {
    const isCover1Open = isCoverOpen(cover1);
    const isCover2Open = isCoverOpen(cover2) && cover2 !== 65534;
    if (isCover1Open && isCover2Open)
        return COVER_POSITIONS.DUAL;
    if (isCover1Open)
        return COVER_POSITIONS.RIGHT;
    if (isCover2Open)
        return COVER_POSITIONS.LEFT;
    return null;
};
/**
 * Проверяет, является ли устройство Galileosky
 */
export const isGalileoskyDevice = (deviceType, deviceTypes) => {
    return deviceTypes[deviceType] === 'galileosky';
};
/**
 * Получает класс цвета по состоянию guard
 */
export const getColorClassByGuardState = (guardState) => {
    const colorMap = {
        0: COLOR_CLASSES.INHERIT,
        1: COLOR_CLASSES.ERROR,
    };
    return colorMap[guardState] || COLOR_CLASSES.INHERIT;
};
/**
 * Получает цвет кнопки по guard_out состоянию
 */
export const getButtonColorByGuardOut = (guardOutBit) => {
    return guardOutBit === '1' ? 'primary' : 'inherit';
};
export const getSensorCountText = (hasDevice, sensorCount, declOfNum) => {
    if (!hasDevice)
        return 'нет датчиков';
    if (sensorCount === config.conditions.sensor_count.default)
        return '';
    if (sensorCount === 0)
        return 'нет датчиков';
    return `${sensorCount} ${declOfNum(sensorCount, ['датчик', 'датчика', 'датчиков'])}`;
};
